/** @format */

import { useEffect, useState } from "react";
import { Brand, Question } from "@question-bank/shared";
import { getQuestion } from "../api/questions";

interface UseQuestionReturn {
	question: Question | null;
	isLoading: boolean;
	error: string | null;
}

export const useQuestion = (brand: Brand, id: string): UseQuestionReturn => {
	const [question, setQuestion] = useState<Question | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let isCancelled = false;
		setIsLoading(true);
		setError(null);
		setQuestion(null);

		getQuestion(brand, id)
			.then((q) => {
				if (!isCancelled) {
					setQuestion(q);
				}
			})
			.catch((err) => {
				if (!isCancelled) {
					setError(err instanceof Error ? err.message : "failed to load question");
				}
			})
			.finally(() => {
				if (!isCancelled) {
					setIsLoading(false);
				}
			});

		return () => {
			isCancelled = true;
		};
	}, [brand, id]);

	return { question, isLoading, error };
};
